import { adminOnly } from '@/routerGuards'

const load = (path) => () => import(/* webpackChwunkName: "[request]" */ `@/views/${path}.vue`)

export default [
  {
    path: '/auth',
    component: load('AuthIndex'),
    meta: {
      auth: false
    },
    children: [
      {
        path: 'login',
        name: 'login',
        component: load('Login')
      },
      {
        path: 'register',
        name: 'register',
        component: load('Register')
      },
      {
        path: 'forgotten-password',
        name: 'forgotten-password',
        component: load('ForgottenPassword')
      },
      {
        path: 'confirm-registration/:confirmKey',
        name: 'confirm-register',
        component: load('ConfirmRegister'),
        props: true
      },
      {
        path: 'password-reset',
        name: 'password-reset',
        component: load('RecoverPassword')
      }
    ]
  },
  {
    path: '/play/:roundId',
    component: load('FastTrack'),
    name: 'fast-track',
    props: true
  },
  {
    path: '/pull-winner/:roundId',
    name: 'pull-winner',
    component: load('PullWinner'),
    beforeEnter: adminOnly,
    props: true
  },
  {
    path: '/pull-random-user',
    name: 'pull-random-user',
    component: load('PullRandomUser'),
    beforeEnter: adminOnly
  },
  {
    path: '/countdown',
    name: 'countdown',
    component: load('Countdown')
  },
  {
    path: '/',
    component: load('layouts/MainLayout'),
    children: [
      {
        path: '',
        name: 'home',
        component: load('Home')
      },
      {
        path: 'about',
        name: 'about',
        component: load('About')
      },
      {
        path: 'how-to-play',
        name: 'how-to-play',
        component: load('HowToPlay')
      },
      {
        path: 'bonus-round',
        name: 'bonus-round',
        component: load('BonusRound')
      },
      {
        path: 'rounds',
        name: 'rounds',
        component: load('Rounds')
      },
      {
        path: 'contact',
        name: 'contact',
        component: load('Contact')
      },
      {
        name: 'round',
        path: 'round/:id',
        component: load('Round'),
        props: true
      },
      {
        name: 'cart',
        path: 'cart',
        component: load('Cart')
      },
      {
        name: 'finish-order',
        path: 'finish-order/:gateway',
        component: load('FinishOrder'),
        props: true
      },
      {
        name: 'checkout.successful',
        path: 'checkout/:id/successful',
        component: load('checkout/Success')
      },
      {
        name: 'checkout.canceled',
        path: 'checkout/:id/canceled',
        component: load('checkout/Cancelled')
      },
      {
        path: 'profile',
        component: load('profile/ProfileIndex'),
        meta: {
          auth: true
        },
        children: [
          {
            name: 'profile.view',
            path: '',
            props: true,
            component: load('profile/ProfileView')
          },
          {
            name: 'profile.edit',
            path: 'edit',
            props: true,
            component: load('profile/ProfileView')
          }
        ]
      },
      {
        path: 'terms',
        name: 'terms',
        component: load('Terms')
      },
      {
        path: 'gdpr',
        name: 'gdpr',
        component: load('GDPR')
      }
    ]
  },
  {
    path: '*',
    redirect: { name: 'home' }
  }
]
